import { render, staticRenderFns } from "./DragDrop.vue?vue&type=template&id=637ec96f"
import script from "./DragDrop.vue?vue&type=script&lang=js"
export * from "./DragDrop.vue?vue&type=script&lang=js"
import style0 from "./DragDrop.vue?vue&type=style&index=0&id=637ec96f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports